"use strict";

PF.Dom.Node = class PfDomNode extends PF.Entity {
    static get options() {
        return {
            eventsTrait: PF.Dom.Node.EventsTrait
        };
    }

    constructor(node) {
        super();
        this.events = [];
        if (typeof node === 'string') {
            // let html = node.replace(/(@\{[A-Za-z0-9\s\-_\.\|]+\})/g, '<span pf-text="$1"></span>');
            if (node.indexOf('@{') >= 0) {
                node = this.replacePfTextToNode(node);
            }
            let template = document.createElement("div");
            template.innerHTML = node.trim();
            if (template.childNodes.length > 1) {
                this.node = template;
            } else {
                if (template.childNodes.length > 0) {
                    this.node = template.childNodes[0];
                } else {
                    this.node = template;
                }
            }
            // this.replacePfTextToNode();
            this.isSet = true;
        }
        if (node instanceof Node) {
            this.node = node;
            this.isSet = true;
        }
    }

    replacePfTextToNode(html) {
        let collect = {};
        html = html.replace(/(<.*".*@\{[A-Za-z0-9\s\-_\.\|]+\}.*?".*?>)/gm, (a1, a2, index) => {
            collect[index + ''] = a2;
            return `%%${index}%%`;
        });
        html = html.replace(/(@\{[A-Za-z0-9\s\-_\.\|]+\})/gm, '<span pf-text="$1"></span>');
        html = html.replace(/\%\%(\d+)\%\%/gm, (a1, a2) => collect[a2]);
        return html;
    }

    bindAll() {
        this.bindHtml();
        this.bindText();
        this.bindDisplay();
        this.bindClasses();
        this.bindAttributes();
        this.bindFocus();
        this.bindValue();
        this.bindEnabled();
    }

    bindInView(child, part) {
        if (this.isInViewBinded !== true) {
            this.isInViewBinded = true;
            this.childsInView = {};
            this.inViewCount = 0;

            this.on('scroll@viewPort', () => {
                for (let id in this.childsInView) {
                    let child = this.childsInView[id].child;

                    let inView = child.inViewPort(this, this.childsInView[id].part);
                    if (inView === true && child.inView === false) {
                        child.trigger('inView');
                    }
                    if (inView === false && child.inView === true) {
                        child.trigger('outView');
                    }
                    child.inView = inView;
                }
            });
        }
        child.inView = false;
        child.inViewId = PF.H.createUUID();
        this.inViewCount++;
        this.childsInView[child.inViewId] = { child: child, part: part };
    }

    unBindInView(child) {
        this.childsInView[child.inViewId] = undefined;
        this.inViewCount--;
        if (this.inViewCount === 0) {
            this.off('scroll@viewPort');
            this.isInViewBinded = false;
        }
    }

    bindContent() {
        if (this.isContentBinded !== true) {
            this.isContentBinded = true;
            this.onChange('content', () => {
                this.empty();
                this.append(this.content);
            });
        }
    }

    bindEnabled() {
        if (this.isEnableBinded !== true) {
            this.isEnableBinded = true;
            this.bindAttributes();
            this.calc('attributes.disabled', 'enabled', (e) => e === false ? 'disabled' : undefined);
        }
    }

    bindValue() {
        if (this.isValueBinded !== true) {
            this.isValueBinded = true;
            this.value = this.node.value || '';
            // this.on('change', () => {
            // 	this.value = this.node.value;
            // });
            this.on('input', () => {
                if (this.node.type === 'checkbox') {
                    this.value = this.node.checked;
                } else if (this.node.type === 'radio') {
                    this.value = this.node.checked;
                } else {
                    this.value = this.node.value;
                }
            });
            this.onChange('value', () => {
                if (this.node.type === 'checkbox') {
                    this.node.checked = this.value;
                } else if (this.node.type === 'radio') {
                    this.node.checked = this.value;
                } else {
                    this.node.value = this.value;
                }
            });
        }
    }

    getHtml() {
        this.html = this.node.innerHTML;
        return this.html;
    }

    getText() {
        this.text = this.node.textContent;
        return this.text();
    }

    bindHtml() {
        if (this.isHtmlBinded !== true) {
            this.isHtmlBinded = true;
            this.html = this.node.innerHTML;
            this.onChange('html', () => {
                this.node.innerHTML = this.html;
            });
        }
    }

    bindText() {
        if (this.isTextBinded !== true) {
            this.isTextBinded = true;
            this.text = this.node.textContent;
            this.onChange('text', () => this.node.textContent = this.text);
        }
    }

    bindDisplay() {
        if (this.isDisplayBinded !== true) {
            this.isDisplayBinded = true;
            this.onValue('display', true, () => this.show());
            this.onValue('display', false, () => this.hide());
        }
    }

    bindStyles() {
        if (this.isStylesBinded !== true) {
            this.isStylesBinded = true;
            this.styles = new PF.EntityProxy({ eventsTrait: PF.Entity.EventsCoreTrait });

            this.styles.on('changeProperty', (key, newValue) => {
                this.css(key, newValue);
            });
        }
    }

    bindClasses() {
        if (this.isClassesBinded !== true) {
            this.isClassesBinded = true;
            this.classes = new PF.EntityProxy({ eventsTrait: PF.Entity.EventsCoreTrait });
            if (this.node.classList !== undefined) {
                for (let i = 0; i < this.node.classList.length; i++) {
                    let name = this.node.classList[i];
                    this.classes[name] = true;
                }
            }
            this.classes.on('beforeChangeProperty', (key, oldValue, newValue) => {
                if (typeof oldValue === 'string') {
                    this.node.classList.remove(oldValue);
                    this.node.classList.add(newValue);
                } else if (typeof newValue === 'string') {
                    this.node.classList.add(newValue);
                } else if (typeof newValue === 'boolean') {
                    this.node.classList.toggle(key, newValue);
                }
            });
        }
    }

    bindAttributes() {
        if (this.isAttributesBinded !== true) {
            this.isAttributesBinded = true;
            this.attributes = new PF.EntityProxy({ eventsTrait: PF.Entity.EventsCoreTrait });
            if (this.node.attributes !== undefined) {
                for (let i = 0; i < this.node.attributes.length; i++) {
                    let name = this.node.attributes[i].name;
                    this.attributes[name] = this.node.attributes[i].value;
                }
            }
            this.attributes.on('changeProperty', (key, value) => {
                if (value === undefined) {
                    this.node.removeAttribute(key);
                } else {
                    this.node.setAttribute(key, value);
                }
            });
        }
    }

    bindFocus() {
        if (this.isFocusBinded !== true) {
            this.isFocusBinded = true;
            this.focus = false;
            this.on('focus', () => this.focus = true);
            this.on('blur', () => this.focus = false);
            this.onValue('focus', true, () => this.node.focus());
        }
    }

    bindObject(object) {
        let nodes = this.find('[pf-text]');
        object['bindedNodes' + PF.H.randomString()] = nodes;
        for (let i = 0; i < nodes.length; i++) {
            let name = nodes[i].node.getAttribute('pf') || PF.H.randomString();
            let key = 'bind_text_' + name;
            object[key] = nodes[i].node.getAttribute('pf-text');
            object.calcString(key);
            nodes[i].bindHtml();
            nodes[i].calc('html', { object: object, key: key });
        }
        this.bindAttributesByObject(object);
    }

    bindAttributesByObject(object, node = this) {
        let attributes = ['href', 'src', 'alt', 'title', 'id', 'for'];
        for (let i = 0, attribute; attribute = attributes[i]; i++) {
            let nodes = this.find(`:scope [${attribute}*="@{"]`);
            for (let j = 0, node; node = nodes[j]; j++) {
                node.bindAttributes();
                let key = 'bind_attribute_' + attribute + '_' + PF.H.randomString();
                object[key] = node.attributes[attribute];
                object.calcString(key);
                node.calc('attributes.' + attribute, { object: object, key: key });
            }
        }
    }

    hasClass(className) {
        return this.node.classList.contains(className);
    }

    addClass(className) {
        this.bindClasses();
        let parts = className.split(" ");
        for (let i = 0; i < parts.length; i++) {
            this.classes[parts[i]] = true;
        }
    }

    removeClass(className) {
        this.bindClasses();
        this.classes[className] = false;
    }

    transform(transform) {
        const style = this.node.style;
        style.webkitTransform = transform;
        style.transform = transform;
    }

    transition(duration) {
        if (typeof duration !== 'string') {
            duration = `${duration}ms`; // eslint-disable-line
        }

        const style = this.node.style;
        style.webkitTransitionDuration = duration;
        style.transitionDuration = duration;
    }

    transitionEnd(callback) {
        const events = ['webkitTransitionEnd', 'transitionend'];
        let fireCallBack = (e) => {
            if (e.target === this.node) {
                callback(e);
                for (let i = 0; i < events.length; i += 1) {
                    this.off(events[i], fireCallBack);
                }
            }
        };
        for (let i = 0; i < events.length; i += 1) {
            this.on(events[i], fireCallBack);
        }
    }

    animationEnd(callback) {
        const events = ['webkitAnimationEnd', 'animationend'];
        let fireCallBack = (e) => {
            if (e.target === this.node) {
                callback.call(this, e);
                for (let i = 0; i < events.length; i += 1) {
                    this.off(events[i], fireCallBack);
                }
            }
        };
        for (let i = 0; i < events.length; i += 1) {
            this.on(events[i], fireCallBack);
        }
    }

    // Sizing/Styles
    width() {
        if (this.node === window) {
            return window.innerWidth;
        }
        // return parseFloat(this.css('width'));
        return this.node.clientWidth;
    }

    setWidth(width) {
        this.css({ width: width });
    }

    outerWidth(includeMargins) {
        if (includeMargins) {
            const styles = this.styles();
            return this.node.offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this.node.offsetWidth;
    }

    height() {
        if (this.node === window) {
            return window.innerHeight;
        }
        return this.node.clientHeight;
        // return parseFloat(this.css('height'));
    }

    setHeight(height) {
        this.css({ height: height });
    }

    outerHeight(includeMargins) {
        if (includeMargins) {
            const styles = this.styles();
            return this.node.offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this.node.offsetHeight;
    }

    offset() {
        const box = this.node.getBoundingClientRect();
        const body = document.body;
        const clientTop = this.node.clientTop || body.clientTop || 0;
        const clientLeft = this.node.clientLeft || body.clientLeft || 0;
        const scrollTop = this.node === window ? window.scrollY : this.node.scrollTop;
        const scrollLeft = this.node === window ? window.scrollX : this.node.scrollLeft;
        return {
            top: (box.top + scrollTop) - clientTop,
            left: (box.left + scrollLeft) - clientLeft,
        };
    }

    hide() {
        this.node.style.display = 'none';
    }

    show() {
        if (this.node.style.display === 'none') {
            this.node.style.display = '';
        }
        if (window.getComputedStyle(this.node, null).getPropertyValue('display') === 'none') {
            this.node.style.display = 'block';
        }
    }

    styles() {
        return window.getComputedStyle(this.node, null);
    }

    css(props, value) {
        if (value === undefined) {
            if (typeof props === 'string') {
                if (this.node) {
                    return this.fromCssValue(props, window.getComputedStyle(this.node, null).getPropertyValue(props));
                }
            } else {
                for (let prop in props) {
                    this.node.style[prop] = this.toCssValue(prop, props[prop]);
                }
            }
        } else if (typeof props === 'string') {
            this.node.style[props] = this.toCssValue(props, value);
        }
    }

    get cssPixelProperties() {
        return {
            'height': true,
            'width': true,
            'margin': true,
            'margin-top': true,
            'margin-bottom': true,
            'margin-left': true,
            'margin-right': true,
            'padding': true,
            'padding-top': true,
            'padding-bottom': true,
            'padding-left': true,
            'padding-right': true,
            'top': true,
            'left': true,
            'right': true,
            'bottom': true,
        };
    }

    toCssValue(property, value) {
        if (property in this.cssPixelProperties) {
            if (typeof value === 'number') {
                return value + 'px';
            }
        }
        return value;
    }

    fromCssValue(property, value) {
        if (property in this.cssPixelProperties) {
            return parseFloat(value);
        }
        return value;
    }

    is(selector) {
        if (selector === undefined) {
            return true;
        }
        if (typeof selector === 'string') {
            if (this.node.matches) {
                return this.node.matches(selector);
            } else if (this.node.webkitMatchesSelector) {
                return this.node.webkitMatchesSelector(selector);
            } else if (this.node.msMatchesSelector) {
                return this.node.msMatchesSelector(selector);
            }
            return false;
        } else if (selector === document) {
            return el === document;
        } else if (selector === window) {
            return el === window;
        }
        return false;
    }

    append(newChild) {
        // this.node.appendChild(newChild.node);
        if (newChild !== undefined) {
            if (!(newChild instanceof PF.Dom.Node)) {
                newChild = new PF.Dom.Node(newChild);
            }
            this.node.append(newChild.node);
        }
    }

    prepend(newChild) {
        // this.node.insertBefore(newChild.node, this.node.childNodes[0]);
        if (newChild !== undefined) {
            this.node.prepend(newChild.node);
        }
    }

    before(newChild) {
        // this.node.before(newChild.node);
        if (newChild !== undefined) {
            this.node.parentNode.insertBefore(newChild.node, this.node);
        }
    }

    after(newChild) {
        // this.node.after(newChild.node);
        if (newChild !== undefined) {
            this.node.parentNode.insertBefore(newChild.node, this.node.nextSibling);
        }
    }

    parent(selector) {
        let parent = new PF.Dom.Node(this.node.parentNode);
        while (parent.isSet) {
            if (parent.is(selector)) {
                return parent;
            }
            parent = new PF.Dom.Node(parent.node.parentNode);
        }
        return undefined;
    }

    parents(selector) {
        let parents = [];
        let parent = new PF.Dom.Node(this.node.parentNode);
        while (parent.isSet) {
            if (parent.is(selector)) {
                parents.push(parent);
            }
            parent = new PF.Dom.Node(parent.node.parentNode);
        }
        return parents;
    }

    isParent(parentCandidate) {
        let parent = new PF.Dom.Node(this.node.parentNode);
        while (parent.isSet) {
            if (parentCandidate.node === parent.node) {
                return true;
            }
            parent = new PF.Dom.Node(parent.node.parentNode);
        }
        return false;
    }

    find(selector) {
        const foundElements = [];
        const found = this.node.querySelectorAll(selector);
        for (let j = 0; j < found.length; j += 1) {
            foundElements.push(new PF.Dom.Node(found[j]));
        }
        return foundElements;
    }

    findOne(selector) {
        const found = this.node.querySelector(selector);
        return new PF.Dom.Node(found);
    }

    static findOne(selector) {
        const found = document.querySelector(selector);
        return new PF.Dom.Node(found);
    }

    remove() {
        if (this.node.parentNode) {
            this.node.parentNode.removeChild(this.node);
        }
    }

    empty() {
        if (this.node.nodeType === 1) {
            for (let j = 0; j < this.node.childNodes.length; j += 1) {
                if (this.node.childNodes[j].parentNode) {
                    this.node.childNodes[j].parentNode.removeChild(this.node.childNodes[j]);
                }
            }
            this.node.textContent = '';
        }
    }

    scrollTo(x, y) {
        this.node.scrollTo(x, y);
    }

    scrollToNode(node, align = 'center') {
        if (align === 'begin') {
            this.node.scrollTo(0, this.node.scrollTop - this.node.getBoundingClientRect().top + node.node.getBoundingClientRect().top);
            // this.node.scrollTo(0, this.shifts(node).top - this.height() / 2 + node.outerHeight(true) / 2);
        }
        if (align === 'center') {
            let h = -this.height() / 2 + node.outerHeight(true) / 2;
            this.node.scrollTo(0, this.node.scrollTop - this.node.getBoundingClientRect().top + node.node.getBoundingClientRect().top + h);
            // this.node.scrollTo(0, this.shifts(node).top);
        }
        if (align === 'end') {
            let h = -this.height() + node.outerHeight(true);
            this.node.scrollTo(0, this.node.scrollTop - this.node.getBoundingClientRect().top + node.node.getBoundingClientRect().top + h);

            // this.node.scrollTo(0, this.shifts(node).top + this.height() / 2 - node.outerHeight(true) / 2);
        }
    }

    inViewPort(viewPort, part = 'full') {
        let t = viewPort.node.scrollTop - viewPort.node.getBoundingClientRect().top + this.node.getBoundingClientRect().top;
        let h = this.height();
        let l = viewPort.node.scrollLeft - viewPort.node.getBoundingClientRect().left + this.node.getBoundingClientRect().left;
        let w = this.width();

        let vt = viewPort.node.scrollTop;
        let vh = viewPort.height();
        let vl = viewPort.node.scrollLeft;
        let vw = viewPort.width();

        let vertInView;
        let horInView;
        if (part === 'full') {
            vertInView = (t >= vt) && (t + h <= vt + vh);
            horInView = (l >= vl) && (l + w <= vl + vw);
        }
        if (part === 'part') {
            vertInView = (t + h >= vt) && (t <= vt + vh);
            horInView = (l + w >= vl) && (l <= vl + vw);
        }
        return (vertInView && horInView);
    }

    shifts(target) {
        return {
            top: target.offset().top - this.offset().top,
            bottom: this.offset().top + this.outerHeight(true) - (target.offset().top + target.outerHeight(true)),
        };
    }

    destroy() {
        this.off();
        this.remove();
        this.isSet = false;
    }
};

PF.Dom.Node.EventsTrait = class DomNodeEventsTrait extends PF.Entity.EventsTrait {
    onDelegate(selector, name, callback) {
        this.on(name, (event) => {
            for (let i = 0; i < event.path.length - 1; i++) {
                let target = new PF.Dom.Node(event.path[i]);
                if (target.is(selector)) {
                    callback();
                }
            }
        });


    }

    on(name, callback, options = {}) {
        if (name instanceof Array) {
            for (let i = 0; i < name.length; i++) {
                this.on(name[i], callback);
            }
            return;
        }

        let clearName = (name || "").split('@')[0];

        if (clearName in MotionEvents) {
            this.initMotion();
        }

        if (clearName in DomEvents) {
            let event = {
                name: name,
                callback: callback,
                clearName: clearName,
                ns: name.split('@')[1] || '',
                options: options,
            };
            event.serviceCallback = (e) => {
                if (event.pause !== true) {
                    callback(e);
                }
            };
            this.events.push(event);
            this.node.addEventListener(clearName, event.serviceCallback, options);
        } else {
            super.on(name, callback);
        }
    }

    off(name, callback) {
        let clearName = (name || "").split('@')[0];
        let ns = (name || "").split('@')[1];

        for (let i = 0; i < this.events.length; i++) {
            if ((this.events[i].clearName === clearName && (this.events[i].ns === ns || ns === undefined) || name === undefined) && (callback === this.events[i].callback || callback === undefined)) {
                this.node.removeEventListener(this.events[i].clearName, this.events[i].serviceCallback, this.events[i].options);
                this.events.splice(i, 1);
                i--;
            }
        }
        super.off(name, callback);
    }

    pauseEvent(name, callback) {
        let clearName = (name || "").split('@')[0];
        let ns = (name || "").split('@')[1];
        if (clearName in DomEvents) {
            for (let i = 0; i < this.events.length; i++) {
                if ((this.events[i].clearName === clearName && (this.events[i].ns === ns || ns === undefined) || name === undefined) && (callback === this.events[i].callback || callback === undefined)) {
                    this.events[i].pause = true;
                }
            }
        } else {
            super.pauseEvent(name, callback);
        }
    }

    resumeEvent(name, callback) {
        let clearName = (name || "").split('@')[0];
        let ns = (name || "").split('@')[1];
        if (clearName in DomEvents) {
            for (let i = 0; i < this.events.length; i++) {
                if ((this.events[i].clearName === clearName && (this.events[i].ns === ns || ns === undefined) || name === undefined) && (callback === this.events[i].callback || callback === undefined)) {
                    this.events[i].pause = false;
                }
            }
        } else {
            super.resumeEvent(name, callback);
        }
    }

    trigger(name, ...args) {
        if (name in DomEvents) {
            let event;
            try {
                event = new window.CustomEvent(name, {
                    detail: args,
                    bubbles: true,
                    cancelable: true,
                });
            } catch (e) {
                event = document.createEvent('Event');
                event.initEvent(name, true, true);
                event.detail = args;
            }
            this.node.dispatchEvent(event);
        } else {
            super.trigger(name, ...args);
        }
    }

    initMotion() {
        if (this.motionInited === true) {
            return;
        }
        this.motionInited = true;
        let holdTimeout;
        let holdEnough;
        let dragCount;
        let startPoint;
        let doc = new PF.Dom.Node(document);
        let body = PF.Dom.Node.findOne('body');
        let serviceStart = (event) => {
            body.addClass("not-selectable");
            dragCount = 0;
            holdEnough = false;
            startPoint = event.point;
            holdTimeout = setTimeout(() => {
                if (dragCount < 3) {
                    this.trigger('hold');
                }
                holdEnough = true;
            }, this.holdTimeout || 700);
            this.trigger('dndStart', event);
        };
        let serviceDrag = (event) => {
            dragCount++;
            this.trigger('dndDrag', event);
        };
        let serviceStop = (event) => {
            body.removeClass("not-selectable");
            clearTimeout(holdTimeout);
            let minMovement = this.minMovement || 5;

            let fireSlide = false;
            if (holdEnough === false) {
                if (startPoint.top - event.point.top > minMovement) {
                    this.trigger('slideUp');
                    fireSlide = true;
                }
                if (startPoint.top - event.point.top < -minMovement) {
                    this.trigger('slideDown');
                    fireSlide = true;
                }
                if (startPoint.left - event.point.left > minMovement) {
                    this.trigger('slideLeft');
                    fireSlide = true;
                }
                if (startPoint.left - event.point.left < -minMovement) {
                    this.trigger('slideRight');
                    fireSlide = true;
                }
                if (fireSlide === false) {
                    this.trigger('fastClick');
                }
            }
            event.fireSlide = fireSlide;
            this.trigger('dndStop', event);

        };

        this.node.ondragstart = () => false;
        this.on('mousedown@motion', (event) => {
            if (event.sourceCapabilities.firesTouchEvents === true) {
                return;
            }
            event.preventDefault();
            serviceStart({ point: { top: event.clientY, left: event.clientX }, originalEvent: event });
            doc.on('mousemove@motion', (event) => {
                serviceDrag({ point: { top: event.clientY, left: event.clientX }, originalEvent: event });
            });
            doc.on('mouseup@motion', (event) => {
                serviceStop({ point: { top: event.clientY, left: event.clientX }, originalEvent: event });
                doc.off('mousemove@motion');
                doc.off('mouseup@motion');
            });
        });

        this.on('touchstart@motion', (event) => {
            if (event.touches.length === 1) {
                serviceStart({ point: { left: event.touches[0].pageX, top: event.touches[0].pageY }, originalEvent: event });
                this.on('touchmove@motion', (event) => {
                    if (event.touches.length === 1) {
                        serviceDrag({ point: { left: event.touches[0].pageX, top: event.touches[0].pageY }, originalEvent: event });
                    }
                });
                this.on('touchend@motion', (event) => {
                    serviceStop({ point: { left: event.changedTouches[0].pageX, top: event.changedTouches[0].pageY }, originalEvent: event });
                    this.off('touchmove@motion');
                    this.off('touchend@motion');
                });
            }
        });
    }


};

const MotionEvents = {
    'dndStart': true,
    'dndDrag': true,
    'dndStop': true,
    'slideUp': true,
    'slideDown': true,
    'slideLeft': true,
    'slideRight': true,
    'fastClick': true,
    'hold': true,
};

const DomEvents = {
    "abort": true,
    "afterprint": true,
    "animationend": true,
    "animationiteration": true,
    "animationstart": true,
    "beforeprint": true,
    "beforeunload": true,
    "blur": true,
    "canplay": true,
    "canplaythrough": true,
    "change": true,
    "click": true,
    "contextmenu": true,
    "copy": true,
    "cut": true,
    "dblclick": true,
    // "drag": true,
    // "dragend": true,
    // "dragenter": true,
    // "dragleave": true,
    // "dragover": true,
    // "dragstart": true,
    "drop": true,
    "durationchange": true,
    "ended": true,
    "error": true,
    "focus": true,
    "focusin": true,
    "focusout": true,
    "fullscreenchange": true,
    "fullscreenerror": true,
    "hashchange": true,
    "input": true,
    "invalid": true,
    "keydown": true,
    "keypress": true,
    "keyup": true,
    "load": true,
    "loadeddata": true,
    "loadedmetadata": true,
    "loadstart": true,
    "message": true,
    "mousedown": true,
    "mouseenter": true,
    "mouseleave": true,
    "mousemove": true,
    "mouseover": true,
    "mouseout": true,
    "mouseup": true,
    "mousewheel": true,
    "offline": true,
    "online": true,
    "open": true,
    "pagehide": true,
    "pageshow": true,
    "paste": true,
    "pause": true,
    "play": true,
    "playing": true,
    "popstate": true,
    "progress": true,
    "ratechange": true,
    "resize": true,
    "reset": true,
    "scroll": true,
    "search": true,
    "seeked": true,
    "seeking": true,
    "select": true,
    "show": true,
    "stalled": true,
    "storage": true,
    "submit": true,
    "suspend": true,
    "timeupdate": true,
    "toggle": true,
    "touchcancel": true,
    "touchend": true,
    "touchmove": true,
    "touchstart": true,
    "transitionend": true,
    "unload": true,
    "volumechange": true,
    "waiting": true,
    "wheel": true,
};